module.exports = "//docs.gtimg.com/slide/img/framework/frame/components/pc-left-thumbnail-list/add-slide-card/ai-beatify-fe2711.svg";